export enum TipoAndamentoEnum {
  EMAIL = 'EMAIL',
  PREVISAOCONCLUSAO = 'PREVISAOCONCLUSAO',
  ANEXOEXTERNO = 'ANEXOEXTERNO',
  OFICIO = 'OFICIO',
  SUSPENSAO = 'SUSPENSAO',
  ALTERACAOCATEGORIA = 'ALTERACAOCATEGORIA'
}

export const tipoAndamentoEnum = {
  EMAIL: 'Email',
  PREVISAOCONCLUSAO: 'Previsão Conclusão',
  ANEXOEXTERNO: 'Anexo Externo',
  OFICIO: 'Ofício',
  SUSPENSAO: 'Suspensão',
  ALTERACAOCATEGORIA: 'Alteração de Categoria'
};
